import { defineMessages } from '@jutro/locale';

export default defineMessages({
    addNote: {
        id: 'ml.gateway.views.ResendESign.MLResendESignComponent.Add Note',
        defaultMessage: 'Add Note'
    },
    cancelModal: {
        id: 'ml.gateway.views.ResendESign.MLResendESignComponent.CANCEL',
        defaultMessage: 'CANCEL'
    },
    emailAddress: {
        id: 'ml.gateway.views.ResendESign.MLResendESignComponent.Resend to',
        defaultMessage: 'Resend to'
    },
    invalidEmail: {
        id: 'ml.gateway.views.ResendESign.MLResendESignComponent.InvalidEmail',
        defaultMessage: 'Enter a valid email address.'
    },
    emailServiceIssue: {
        id: 'ml.gateway.views.ResendESign.MLResendESignComponent.emailServiceIssue',
        defaultMessage: 'Email validation services are delayed, please verify the email entered is correct, and then proceed'
    },
    groupID: {
        id: 'ml.gateway.views.ResendESign.MLResendESignComponent.GroupID',
        defaultMessage: 'Group Doc ID'
    },
    groupInviteID: {
        id: 'ml.gateway.views.ResendESign.MLResendESignComponent.GroupInviteID',
        defaultMessage: 'Group Invite ID'
    },
    resendDocuments: {
        id: 'ml.gateway.views.ResendESign.MLResendESignComponent.ResendDocuments',
        defaultMessage: 'Resend Documents'
    },
    documents: {
        id: 'ml.gateway.views.ResendESign.MLResendESignComponent.Documents',
        defaultMessage: 'Document(s)'
    },
    currentStep: {
        id: 'ml.gateway.views.ResendESign.MLResendESignComponent.Current Step',
        defaultMessage: 'Current Step'
    },
    waitingStep: {
        id: 'ml.gateway.views.ResendESign.MLResendESignComponent.Waiting for Previous Signature',
        defaultMessage: 'Waiting for Previous Signature'
    },
    waitingStepMsg: {
        id: 'ml.gateway.views.ResendESign.MLResendESignComponent.Waiting for Previous Signature Message',
        defaultMessage: 'Once the primary insured completes all documents in the eSign packet, the system will automatically initiate the process for collecting any additional required signature(s).'
    },
    closeBtnLabel: {
        id: 'ml.gateway.views.ResendESign.MLResendESignComponent.CLOSE',
        defaultMessage: 'CLOSE'
    }    
});
